module.exports = __webpack_public_path__ + "static/img/6.21f6606.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/eng/6.png
// module id = vneF
// module chunks = 0